import React          from 'react'
import { withRouter } from 'react-router'

import { Keyboard            } from 'alto-react-components/lib/components'
import { ChangePasswordPanel } from 'alto-react-client-auth/lib/components'

class CanteenChangePasswordPanel extends ChangePasswordPanel.WrappedComponent
  constructor: (props, context) ->
    super(props, context)

    @showKeyboard = context.auth.isTerminal

    @currentPasswordRef = React.createRef()
    @newPasswordRef     = React.createRef()
    @confirmationRef    = React.createRef()
    @pinRef             = React.createRef()
    @keyboardRef        = React.createRef()

    @state.keyboardInput = 'currentPassword'

  render: ->
    <React.Fragment>
      {super()}
      {@keyboard() if @showKeyboard}
    </React.Fragment>

  additionalCurrentPasswordProps: ->
    inputRef: (ref) => @currentPasswordRef = ref
    onFocus:  => @setKeyboardInput('currentPassword')

  additionalNewPasswordProps: ->
    inputRef: (ref) => @newPasswordRef = ref
    onFocus:  => @setKeyboardInput('newPassword')

  additionalConfirmationPasswordProps: ->
    inputRef: (ref) => @confirmationRef = ref
    onFocus:  => @setKeyboardInput('passwordConfirmation')

  additionalPinInputProps: ->
    inputRef: (ref) => @pinRef = ref
    onFocus:  => @setKeyboardInput('pin')

  keyboard: ->
    <Keyboard
     ref={@keyboardRef}
     value={@state[@state.keyboardInput]}
     onChange={(value) => @setState([@state.keyboardInput]: value)}
     onAccepted={@keyboardAccepted.bind(@)} />

  setKeyboardInput: (input) ->
    if @showKeyboard and input != @state.keyboardInput
      @keyboardRef.current.resetKeyboard()
      @setState(keyboardInput: input)

  keyboardAccepted: ->
    refToFocus = @nextInputToFocus()

    if refToFocus
      setTimeout((-> refToFocus.focus()), 10)
    else
      @submit() if @isValid()

  nextInputToFocus: ->
    switch @state.keyboardInput
      when 'currentPassword'      then @newPasswordRef
      when 'newPassword'          then @confirmationRef
      when 'passwordConfirmation' then if @pinEnabled then @pinRef else null
      when 'pin'                  then null

export default withRouter(CanteenChangePasswordPanel)
